/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Contact_SubmitInputs */

const cs_public_site_contact_submit = /** @type {(inputs: Public_Site_Contact_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat poptávku`)
};

const en_public_site_contact_submit = /** @type {(inputs: Public_Site_Contact_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send inquiry`)
};

/**
* | output |
* | --- |
* | "Send inquiry" |
*
* @param {Public_Site_Contact_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_contact_submit = /** @type {((inputs?: Public_Site_Contact_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Contact_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_contact_submit(inputs)
	return cs_public_site_contact_submit(inputs)
});